import React from "react";
import Cookies from "universal-cookie";

import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import HomePage from "./views/Home/Home";
import SignIn from "./views/SignIn/SignIn";
import Dashboard from "./views/Dashboard/Dashboard";
import Student from "./views/Student/Student";
import PageNotFound from "./views/PageNotFound/PageNotFound";
import SuccessfulRequest from "./views/SuccessfulRequest/SuccessfulRequest";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assits/css/main-dashboards.min.css";

export default () => {
  const cookies = new Cookies();

  const handleLogin = (response) => {
    const { username } = response.data.admin;
    cookies.set("userLoggedIn", username, { path: "/" });
  };
  const alreadyLoggedIn = cookies.get("userLoggedIn");
  return (
    <Router basename={process.env.REACT_APP_BASENAME || ""}>
      <Switch>
        <Route exact path="/" component={HomePage} />
        <Route
          path="/sign-in"
          render={(props) =>
            !cookies.get("userLoggedIn") ? (
              <SignIn
                {...props}
                handleLogin={handleLogin}
                alreadyLoggedIn={alreadyLoggedIn}
              />
            ) : (
              <Redirect
                to={{
                  pathname: "/nonverified",
                  state: {
                    from: props.location,
                  },
                }}
              />
            )
          }
        />

        <PrivateRoute
          path="/nonverified"
          component={Dashboard}
          verified={false}
        />
        <PrivateRoute path="/verified" component={Dashboard} verified={true} />
        <PrivateRoute exact path="/students/:id" component={Student} />

        <Route path="/successful-request" component={SuccessfulRequest} />
        <Route component={PageNotFound} />
      </Switch>
    </Router>
  );
};
